export const deviceMixin = {
  computed: {
    deviceClass () {
      return this.$deviceState.isMobile ? 'mb_area' : 'pc_area'
    }
  }
}
